// Controllers
export const API_PREFIX = 'api';
export const API_ADMIN_PREFIX = 'admin';

export const API_ACCOUNTCONTROLLER = 'account';
export const API_ACCOUNTINGTYPECONTROLLER = 'accountingtype';
export const API_ANALYTICSCONTROLLER = 'analytics';
export const API_ACTION_CATEGORIES = 'categories';
export const API_CLIENTCONTROLLER = 'client';
export const API_CLOCONTROLLER = 'clo';
export const API_COMPANYCONTROLLER = 'company';
export const API_COMPANYREPORTINGTYPECONTROLLER = 'companyreportingtype';
export const API_COMPANYTRANSACTIONTYPECONTROLLER = 'companytransactiontype';
export const API_COMPLIANCECONTROLLER = 'compliance';
export const API_CONNECTCONTROLLER = 'connect';
export const API_COVENANTREVIEWCONTROLLER = 'covenantreview';
export const API_COVENANTREVIEWQUICKFILTERTYPECONTROLLER = 'covenantreviewquickfiltertype';
export const API_CURRENCYCONTROLLER = 'currency';
export const API_DATASITEHOSTCONTROLLER = 'datasitehost';
export const API_DATASITEPROVIDERCONTROLLER = 'datasiteprovider';
export const API_DATASITESCONTROLLER = 'datasite';
export const API_DATASITESTATUSCONTROLLER = 'datasitestatus';
export const API_DATASITETYPECONTROLLER = 'datasitetype';
export const API_DEBTISSUANCETYPECONTROLLER = 'debtissuancetype';
export const API_DOCUMENTSCONTROLLER = 'documents';
export const API_FEATUREFLAGCONTROLLER = 'featureflag';
export const API_HELPCENTERCONTROLLER = 'helpcenter';
export const API_INDUSTRYCONTROLLER = 'industry';
export const API_FITCHINDUSTRYCONTROLLER = 'fitchIndustry';
export const API_INDUSTRYGROUPCONTROLLER = 'industrygroup';
export const API_NEWSCONTROLLER = 'news';
export const API_NEWSTYPECONTROLLER = 'newstype';
export const API_PLANNERCONTROLLER = 'planner';
export const API_PRIVATEEQUITYSPONSORCONTROLLER = 'privateequitysponsor';
export const API_RELEASEFEATUREFLAGCONTROLLER = 'releasefeatureflag';
export const API_SECTORCONTROLLER = 'sector';
export const API_SETTINGSCONTROLLER = 'settings';
export const API_SUBSCRIPTIONCONTROLLER = 'subscription';
export const API_TAGSCONTROLLER = 'tags';
export const API_TRANSCRIPTIONSCONTROLLER = 'transcription';
export const API_USERCONTROLLER = 'user';
export const API_USERACTIVITYCONTROLLER = 'useractivity';
export const API_USERTITLECONTROLLER = 'usertitle';

// Actions
export const API_ACTION_ACCOUNT_COMPANY_ALERTS = 'alertsenabled';
export const API_ACTION_ACCOUNT_COMPANY_MYPORTFOLIO = 'myportfolio';
export const API_ACTION_ACCOUNT_COMPANY = 'companies';
export const API_ACTION_ACCOUNT_SECTOR_ALERTS = 'alertsenabled';
export const API_ACTION_ACCOUNT_SECTOR_MYPORTFOLIO = 'myportfolio';
export const API_ACTION_ACCOUNT_SECTOR = 'sectors';
export const API_ACTION_ACCOUNT_INDUSTRYGROUP_ALERTS = 'alertsenabled';
export const API_ACTION_ACCOUNT_INDUSTRYGROUP_MYPORTFOLIO = 'myportfolio';
export const API_ACTION_ACCOUNT_INDUSTRYGROUP = 'industrygroups';
export const API_ACTION_ANALYTICS_COMPANY = 'company';
export const API_ACTION_APPROVE = 'approve';
export const API_ACTION_CLO = 'clo';
export const API_ACTION_CLO_ANALYTICS = 'analytics';
export const API_ACTION_DEAL_CLO_ANALYTICS = 'dealanalytics';
export const API_ACTION_CLO_INDUSTRIES = 'cloIndustries';
export const API_ACTION_CLO_DEAL_INDUSTRIES = 'cloDealIndustries';
export const API_ACTION_CLO_SFDR_REPORT = 'closfdrreport';
export const API_ACTION_CLO_SFDR_WHITE_REPORT = 'sfdrwhitepaper';
export const API_ACTION_ANALYTICS_MARKETDATA = 'marketData';
export const API_ACTION_COMPANY_ALERTS = 'alertsenabled';
export const API_ACTION_COMPANY_ANALYST_NOTES = 'analystnotes';
export const API_ACTION_COMPANY_CLIENT_ADD = 'add';
export const API_ACTION_COMPANY_CLIENT_EBITDA = 'ebitda';
export const API_ACTION_COMPANY_CLIENT_DEAL_NOTES = 'dealnotes';
export const API_ACTION_USER_FORGOTPASSWORD = 'forgotPassword';
export const API_ACTION_RESETPASSWORD = 'resetPassword';
export const API_ACTION_USER_VERIFYPASSWORDRESETTOKEN = 'verifyPasswordResetToken';
export const API_ACTION_USER_USEREMAILCONFIRMATION = 'userEmailConfirmation';
export const API_ACTION_USER_VERIFYUSEREMAILCONFIRMATIONTOKEN = 'verifyUserEmailConfirmationToken';
export const API_ACTION_COMPANIES = 'companies';
export const API_ACTION_COMPANY = 'company';
export const API_ACTION_HEALTH = 'health';
export const API_ACTION_HISTORIES = 'histories';
export const API_ACTION_COMPANY_NEWS = 'news';
export const API_ACTION_COMPANY_COMPS = 'comps';
export const API_ACTION_SEARCH = 'search';
export const API_ACTION_SEARCH_MNPI = 'search-mnpi';
export const API_ACTION_PORTFOLIO = 'portfolio';
export const API_ACTION_MYPORTFOLIO = 'myportfolio';
export const API_ACTION_TRANSACTION_COMPS = 'transactioncomps';
export const API_ACTION_DOWNLOAD = 'download';
export const API_ACTION_DOWNLOAD_MULTIPLE = 'download-multiple';
export const API_ACTION_DOWNLOAD_ZIP = 'download-zip';
export const API_ACTION_RETRIEVE = 'retrieve';
export const API_ACTION_RESTORE = 'restore';
export const API_ACTION_SUGGESTED_TAGS = 'suggestedTags';
export const API_ACTION_SUBMIT_SUGGESTED_TAGS = 'suggestedTagsSubmit';
export const API_ACTION_GENERATE = 'generate';
export const API_ACTION_BIXBY = 'bixby';
export const API_ACTION_PRIMER = 'primer';
export const API_ACTION_TEARSHEET = 'tearsheet';
export const API_ACTION_HISTORICAL_PRIMER = 'historical-primer';
export const API_ACTION_HISTORICAL_TEARSHEET = 'historical-tearsheet';
export const API_ACTION_HISTORICAL_FINANCIAL_MODEL = 'historical-financial-model';
export const API_ACTION_PUBLISH = 'publish';
export const API_ACTION_PUBLISHED = 'published';
export const API_ACTION_REPUBLISH = 'republish';
export const API_ACTION_PENDING_APPROVAL_SUMMARY = 'pending-approval-summary';
export const API_ACTION_PENDING_REQUIRES_APPROVAL = 'pendingrequiresapproval';
export const API_ACTION_PORTAL = 'portal';
export const API_ACTION_DELETED = 'deleted';
export const API_ACTION_DELETE_FROM_DB = 'delete-from-db';
export const API_ACTION_ERROR = 'error';
export const API_ACTION_CLIENT = 'client';
export const API_ACTION_USERS = 'users';
export const API_ACTION_USER_DATASITEPROVIDERS = 'datasiteproviders';
export const API_ACTION_CONNECT_LOGOUT = 'logout';
export const API_ACTION_CONNECT_TOKEN = 'token';
export const API_ACTION_CLIENT_COMPANYIVITETOKENS = 'companyinvitetokens';
export const API_ACTION_CLIENT_COMPANYIVITETOKENS_VERIFY = 'verify';
export const API_ACTION_CLIENT_APICREDENTIALS = 'credentials';
export const API_ACTION_TRANSCRIPT_UPLOAD = 'upload';
export const API_ACTION_TRANSCRIPT_SAVE_PLANNER_APPROVAL_TASK = 'save-planner-approval-task';
export const API_ACTION_AUDIO = 'audio';
export const API_ACTION_TEXT = 'text';
export const API_ACTION_UPDATE = 'update';
export const API_ACTION_DOCUMENTS = 'documents';
export const API_ACTION_DOCUMENT_ANNOUNCEMENT = 'document-announcement';
export const API_ACTION_PREVALIDATE_FILES = 'prevalidate-files';
export const API_ACTION_PREVALIDATE_ZIP = 'prevalidate-zip';
export const API_ACTION_VALIDATE = 'validate';
export const API_ACTION_VIDEOS = 'videos';
export const API_ACTION_SUBMIT = 'submit';
export const API_ACTION_SUBMIT_BULK = 'submit-bulk';
export const API_ACTION_SUBMIT_ZIP = 'submit-zip';
export const API_ACTION_WATERMARK_STATUS = 'watermark-status';
export const API_ACTION_PUBLIC = 'public';
export const API_ACTION_PRIVATE = 'private';
export const API_ACTION_DOWNLOAD_FROM_ZIP = 'download-from-zip';
export const API_ACTION_DECLARATIONS = 'declarations';
export const API_ACTION_DECLARATION_FORM = 'form';
export const API_ACTION_USER_DECLARATIONS = 'user-declaration';
export const API_ACTION_PORTFOLIO_DECLARATIONS = 'declaration-portfolio';
export const API_ACTION_TASK = 'task';
export const API_ACTION_TRACK = 'track';
export const API_ACTION_REJECT = 'reject';
export const API_ACTION_REQUEST = 'request';
export const API_ACTION_COVENANT_REVIEW_GLOBAL_FEED = 'feeds/global';
export const API_ACTION_COVENANT_REVIEW_GLOBAL_FEED_COMPANY = 'feeds/global/company';
export const API_ACTION_TAGS_SUGGEST = 'suggest';
export const API_ACTION_IMPORT = 'import';
export const API_ACTION_IMPORT_TEMPLATE = 'import-template';
export const API_ACTION_CREATE_DEDICATED_FINANCIALS = 'create-dedicated-financials';
export const API_ACTION_REMOVE_WATERMARK = 'remove-watermark'
export const API_ACTION_DOWNLOAD_WATERMARK_REMOVED_FILES = 'download-all-watermark-removed-files'
export const API_ACTION_GET_COMPANY_ISSUER_LEVEL_MAPPING = 'issuer-level-mapping';
export const API_ACTION_UPDATE_COMPANY_ISSUER_LEVEL_MAPPING = 'issuer-level-mapping-update';

// Params
export const API_PARAMS_PARTIALNAME = 'partialName';
export const API_PARAMS_COMPANYID = 'CompanyId';
export const API_PARAMS_NEWSTIMEFRAME = 'NewsTimeframe';
export const API_PARAMS_NEWSTYPEID = 'NewsTypeId';
export const API_PARAMS_TIMEZONE = 'Timezone';
export const API_PARAMS_DRAFT = 'draft';
export const API_PARAMS_CREATENEWSREQUEST = 'createNewsRequest';
export const API_PARAMS_SEARCHNAME = 'searchName';
export const API_PARAMS_FILTER = 'filter';

// Storage
const cachePrefix = 'bixby';
export const CACHE_BIXBY_ACCESS_TOKEN = `${cachePrefix}.access_token`;
export const CACHE_BIXBY_REFRESH_TOKEN = `${cachePrefix}.refresh_token`;
export const CACHE_DISCLAIMER_ACKNOWLEDGED_DATE = `${cachePrefix}.disclaimer_acknowledged_date`;
export const CACHE_STATIC_ACCOUNTING_TYPES = `${cachePrefix}.static.accounting_types`;
export const CACHE_STATIC_COMPANY_REPORTING_TYPES = `${cachePrefix}.static.company_reporting_types`;
export const CACHE_STATIC_COMPANY_TRANSACTION_TYPES = `${cachePrefix}.static.company_transaction_types`;
export const CACHE_STATIC_COVENANT_REVIEW_QUICK_FILTER_TYPES = `${cachePrefix}.static.covenant_review_quick_filter_types`;
export const CACHE_STATIC_CURRENCIES = `${cachePrefix}.static.currencies`;
export const CACHE_STATIC_DATA_SITE_HOSTS = `${cachePrefix}.static.data_site_hosts`;
export const CACHE_STATIC_DATA_SITE_PROVIDERS = `${cachePrefix}.static.data_site_providers`;
export const CACHE_STATIC_DATA_SITE_STATUS = `${cachePrefix}.static.data_site_status`;
export const CACHE_STATIC_DATA_SITE_TYPES = `${cachePrefix}.static.data_site_types`;
export const CACHE_STATIC_DEBT_ISSUANCE_TYPES = `${cachePrefix}.static.debt_issuance_types`;
export const CACHE_STATIC_INDUSTRIES = `${cachePrefix}.static.industries`;
export const CACHE_STATIC_INDUSTRY_GROUPS = `${cachePrefix}.static.industry_groups`;
export const CACHE_STATIC_FITCH_INDUSTRIES = `${cachePrefix}.static.fitchIndustries`;
export const CACHE_STATIC_NEWS_TYPES = `${cachePrefix}.static.news_types`;
export const CACHE_STATIC_SECTORS = `${cachePrefix}.static.sectors`;
export const CACHE_STATIC_SUBSCRIPTIONS = `${cachePrefix}.static.subscriptions`;
export const CACHE_STATIC_USER_TITLES = `${cachePrefix}.static.user_titles`;
export const CACHE_STATIC_DATA_SITE_TYPES_REFRESHED = `${cachePrefix}.static.data_site_types_refreshed`;
export const CACHE_STATIC_CURRENCIES_REFRESHED = `${cachePrefix}.static.currencies_refreshed`;

// Login
export const LOGIN_WELCOME_MESSAGE = 'Welcome Back.';
export const LOGIN_EMAIL_PLACEHOLDER = 'Email';
export const LOGIN_PASSWORD_PLACEHOLDER = 'Password';
export const LOGIN_ROLES_ADMIN = 'admin';
export const LOGIN_ROLES_DOCHOSTINGADMIN = 'dochostingadmin';
export const LOGIN_ROLES_CLIENTCOMPLIANCEADMIN = 'clientcomplianceadmin';
export const LOGIN_ROLES_BIXBYCOMPLIANCEADMIN = 'bixbycomplianceadmin';
export const LOGIN_ROLES_COMPANYMNPIINFOADMIN = 'companymnpiinfoadmin';
export const LOGIN_ROLES_COMPANYPUBLICINFOADMIN = 'companypublicinfoadmin';
export const LOGIN_ROLES_SUPERADMIN = 'superadmin';
export const LOGIN_ROLES_CLIENT = 'client';
export const LOGIN_ROLES_CLIENTCONSULTANT = 'clientconsultant';
export const LOGIN_ROLES_CREDITSIGHTSANALYST = 'creditsightsanalyst';
export const LOGIN_ROLES_CREDITSIGHTSOPS = 'creditsightsops';
export const LOGIN_ROLES_SUFANALYST = 'sufanalyst';
export const LOGIN_ROLES_RATINGSANALYST = 'ratingsanalyst';
export const LOGIN_ROLES_LEGALADMIN = 'legaladmin';

// Navigation
export const NAV_WELCOME_MESSAGE = 'Welcome, {0}.';

// Forgot Password
export const FORGOT_PASSWORD_MESSAGE = 'Forgot your password?';
export const FORGOT_PASSWORD_EMAIL = 'Email';
export const FORGOT_PASSWORD_EMAIL_REQUIRED = 'Email is required.';
export const FORGOT_PASSWORD_SENT_MESSAGE =
  'Thank you. An email with instructions on how to reset your password has been sent.';
export const FORGOT_PASSWORD_ERROR_MESSAGE = 'There was an error resetting your password';

// Reset Password
export const RESET_PASSWORD_MESSAGE = 'Reset Your Password';
export const RESET_PASSWORD_SUCCESS_MESSAGE = 'Password Reset Successful';
export const PASSWORD_PLACEHOLDER = 'xxxxxxxx';

// User Email Confirmation
export const USER_EMAIL_CONFIRMATION_SUCCESS_MESSAGE = 'User Email Confirmed';

// Verify Company
export const VERIFY_COMPANY_SUCCESS_MESSAGE = 'Company Verified';

// Application Insight Events
export const APPINSIGHTS_PROFILE_LOADED = 'profile_loaded';
export const APPINSIGHTS_FEEDBACK_LINK_CLICK = 'feedback_link_click';
export const APPINSIGHTS_PORTFOLIO_SPREAD_INVALID = 'portfolio_spread_invalid';
export const APPINSIGHTS_TRANSCRIPTIONS_CLIENT_AUDIO_DOWNLOAD = 'transcriptions_client_audio_download';
export const APPINSIGHTS_TRANSCRIPTIONS_CLIENT_TEXT_DOWNLOAD = 'transcriptions_client_text_download';
export const APPINSIGHTS_TRANSCRIPTIONS_CLIENT_TEXT_RETRIEVE = 'transcriptions_client_text_retrieve';
export const APPINSIGHTS_TRANSCRIPTIONS_ADMIN_REVIEW_AUDIO_DOWNLOAD = 'transcriptions_admin_review_audio_download';
export const APPINSIGHTS_TRANSCRIPTIONS_ADMIN_REVIEW_TEXT_DOWNLOAD = 'transcriptions_admin_review_text_download';
export const APPINSIGHTS_DOCUMENTS_DOWNLOAD = 'company_documents_download';
export const APPINSIGHTS_USERACTIVITY_DOWNLOAD = 'useractivity_download';

// Search
export const SEARCH_CATEGORY_COMPANY = 'Companies';

// Financial Statement Grid Indexes
export const STATEMENT_HEADER = 6;
export const STATEMENT_SPLICE_ROWS = 7;

// Email Domains
export const EMAIL_DOMAIN_BIXBY = 'bixbyresearch.com';

// Admin Rating Row Indexes
export const ROW_RATING = 0;
export const ROW_WARF = 1;
export const ROW_RECOVERY_RATING = 1;
export const ROW_OUTLOOK = 2;
export const ROW_WATCH = 3;

// Grid Styling
export const SPREADSHEET_STYLE_EMPTY = 'empty';
export const SPREADSHEET_STYLE_BORDER_LEFT = 'border-left';
export const SPREADSHEET_STYLE_BORDER_TOP = 'border-top';
export const SPREADSHEET_STYLE_BORDER_RIGHT = 'border-right';
export const SPREADSHEET_STYLE_BORDER_BOTTOM = 'border-bottom';
export const SPREADSHEET_STYLE_BOLD = 'bold';
export const SPREADSHEET_STYLE_UNDERLINE = 'underline';
export const SPREADSHEET_STYLE_ITALICS = 'italics';
export const SPREADSHEET_STYLE_FONT_COLOR = 'font-color';
export const SPREADSHEET_STYLE_FILL_COLOR = 'fill-color';
export const SPREADSHEET_STYLE_HIDE = 'hide';

// Loan Details
export const MATURITY_EMPTY = 'N/A';
export const ZERO = '0';

// Export Types
export const EXPORT_FINANCIALMODEL = 'Financial Model';
export const EXPORT_TEARSHEET = 'Tearsheet';
export const EXPORT_PRIMER = 'Primer';
export const EXPORT_NEWS = 'News';
export const EXPORT_FINANCIALMODEL_DRAFT = 'DRAFT - Financial Model';

// Generated Documents
export const GENERATED_DOCUMENTS = 'generated-documents';
export const GENERATED_DOCUMENTS_BIXBY = '_Bixby';
export const TEARSHEET = 'tearsheet.pdf';
export const PRIMER = 'primer.pdf';

// Analytics Dropdown Types
export const ANALYTICS_VIEW_ALL = 'View All';
export const ANALYTICS_PORTFOLIO = 'Portfolio Metrics Only';
export const ANALYTICS_TRANSACTION_COMPS = 'Transaction Comps Only';

// Portfolio Dropdown Types
export const PORTFOLIO_VIEW_ALL = 'Portfolio View - All';
export const PORTFOLIO_VIEW_MINE = 'Portfolio View - MyPortfolio';
export const PORTFOLIO_VIEW_PRIVATE = 'Portfolio View - Private Companies';
export const PORTFOLIO_VIEW_PUBLIC = 'Portfolio View - Public Companies';
export const PORTFOLIO_VIEW_SYNDICATION = 'New Issue / Syndication';
export const PORTFOLIO_VIEW_PUBLIC_EXCLUDE_DEFUNCT = 'Public Companies (Exclu. Defunct)';

// Feature Flags
export const CLIENT_ANALYTICS_VIEW = 'client_analytics_view';
export const CLIENT_BIXBY_COMPLIANCE = 'client_bixby_compliance';
export const CLIENT_BIXBY_COMPLIANCE_AUTO_APPROVAL = 'client_bixby_compliance_auto_approval';
export const CLIENT_BIXBY_COMPLIANCE_DEMO_MODE = 'client_bixby_compliance_demo_mode';
export const CLIENT_CLO_VIEW = 'client_clo_view';
export const CLIENT_COMPANY_COMPS = 'client_company_comps';
export const CLIENT_COMPANY_DEAL_NOTES = 'client_company_deal_notes';
export const CLIENT_COMPANY_DOCUMENTS = 'client_company_documents';
export const CLIENT_COMPANY_EXCEL_ACCESS = 'client_company_excel_access';
export const CLIENT_COMPANY_TRANSCRIPTIONS_VIEW = 'client_company_transcriptions_view';
export const CLIENT_CREDITSIGHTS_COVENANT_REVIEW = 'client_creditsights_covenant_review';
export const CLIENT_ORG_CHART_VIEW = 'client_org_chart_view';
export const CLIENT_PUBLIC_COMPANIES = 'client_public_companies';
export const CLIENT_SFDR_VIEW = 'client_sfdr_view';
export const CLIENT_US_EURO_GROUPING = 'client_us_euro_grouping';
export const CLIENT_IS_IN_PREVIEW = 'client_is_in_preview';
export const CLIENT_IS_CUTOVER_TO_CREDITSIGHTS = 'client_is_cutover_to_creditsights';

// Transcription State Display
export const TRANSCRIPTION_STATE_PAST_ERROR = 'Error';
export const TRANSCRIPTION_STATE_PAST_DUE = 'Past Due';
export const TRANSCRIPTION_STATE_PENDING_APPROVAL = 'Pending Approval';
export const TRANSCRIPTION_STATE_PUBLISHED = 'Published';

// Document Hosting Validation Errors
export const DOCUMENT_HOSTING_CLIENT_REQUIRED = 'ClientRequired';
export const DOCUMENT_HOSTING_WATERMARKED_DOCUMENT_ALREADY_EXISTS = 'WatermarkedDocumentAlreadyExists';
export const DOCUMENT_HOSTING_MULTIPLE_EXCEL_MATCHES_FOUND = 'MultipleExcelMatchesFound';
export const DOCUMENT_HOSTING_INVALID_ROW_NUMBER = 'InvalidRowNumber';
export const DOCUMENT_HOSTING_NON_WATERMARKED_DOCUMENT_ALREADY_EXISTS = 'NonWatermarkedDocumentAlreadyExists';
export const DOCUMENT_HOSTING_MATCH_NOT_FOUND = 'MatchNotFound';
export const DOCUMENT_HOSTING_SFDR_WHITEPAPER = 'SFDRWhitePaper';
export const DOCUMENT_HOSTING_INVALID_DECLARATION_TYPE = 'InvalidDeclarationType';

// Document Hosting Watermark Removal
export const DOCUMENT_HOSTING_WATERMARK_FROM_DATA_SITE = "WatermarkFromDataSite";
export const DOCUMENT_HOSTING_WATERMARK_REMOVED = "WatermarkRemoved";

// Data Site Providers
export const DATASITEPROVDIER_SYNDTRAK = 'syndtrak';
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

// Date Site Types
export const DATASITETYPE_SYNDICATION = 'f1fa5ddc-fb60-4463-b1f2-60fd6476bc97';

export const URL_REGEX = /^(https?:\/\/)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]{2,})+(:\d{1,5})?(\/[^?#\s]*)?(\?[^#\s]*)?(#[^\s]*)?$/;

// Default Timezones
export const DEFAULTTIMEZONES = [
  {
    DisplayName: 'Pacific Time (US & Canada)',
    Id: 'Pacific Standard Time',
    Abbreviation: 'PST',
  },
  {
    DisplayName: 'Mountain Time (US & Canada)',
    Id: 'Mountain Standard Time',
    Abbreviation: 'MST',
  },
  {
    DisplayName: 'Central Time (US & Canada)',
    Id: 'Central Standard Time',
    Abbreviation: 'CST',
  },
  {
    DisplayName: 'Eastern Time (US & Canada)',
    Id: 'Eastern Standard Time',
    Abbreviation: 'EST',
  }
]

// Timezones
export const TIMEZONES = [
  {
    DisplayName: '(UTC-12:00) International Date Line West',
    Id: 'Dateline Standard Time',
    Abbreviation: 'UTC-12',
  },
  { DisplayName: '(UTC-11:00) Coordinated Universal Time-11', Id: 'UTC-11', Abbreviation: 'UTC-11' },
  { DisplayName: '(UTC-10:00) Aleutian Islands', Id: 'Aleutian Standard Time', Abbreviation: 'HAT' },
  { DisplayName: '(UTC-10:00) Hawaii', Id: 'Hawaiian Standard Time', Abbreviation: 'HST' },
  {
    DisplayName: '(UTC-09:30) Marquesas Islands',
    Id: 'Marquesas Standard Time',
    Abbreviation: 'French Polynesia Time',
  },
  { DisplayName: '(UTC-09:00) Alaska', Id: 'Alaskan Standard Time', Abbreviation: 'AKT' },
  { DisplayName: '(UTC-09:00) Coordinated Universal Time-09', Id: 'UTC-09', Abbreviation: 'UTC-9' },
  { DisplayName: '(UTC-08:00) Baja California', Id: 'Pacific Standard Time (Mexico)', Abbreviation: 'PT' },
  { DisplayName: '(UTC-08:00) Coordinated Universal Time-08', Id: 'UTC-08', Abbreviation: 'UTC-8' },
  { DisplayName: '(UTC-08:00) Pacific Time (US & Canada)', Id: 'Pacific Standard Time', Abbreviation: 'PT' },
  { DisplayName: '(UTC-07:00) Arizona', Id: 'US Mountain Standard Time', Abbreviation: 'MT' },
  {
    DisplayName: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    Id: 'Mountain Standard Time (Mexico)',
    Abbreviation: 'Mexico Time',
  },
  { DisplayName: '(UTC-07:00) Mountain Time (US & Canada)', Id: 'Mountain Standard Time', Abbreviation: 'MT' },
  { DisplayName: '(UTC-07:00) Yukon', Id: 'Yukon Standard Time', Abbreviation: 'Canada Time' },
  { DisplayName: '(UTC-06:00) Central America', Id: 'Central America Standard Time', Abbreviation: 'CT' },
  { DisplayName: '(UTC-06:00) Central Time (US & Canada)', Id: 'Central Standard Time', Abbreviation: 'CT' },
  { DisplayName: '(UTC-06:00) Easter Island', Id: 'Easter Island Standard Time', Abbreviation: 'EAST' },
  {
    DisplayName: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    Id: 'Central Standard Time (Mexico)',
    Abbreviation: 'CT',
  },
  { DisplayName: '(UTC-06:00) Saskatchewan', Id: 'Canada Central Standard Time', Abbreviation: 'CT' },
  {
    DisplayName: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
    Id: 'SA Pacific Standard Time',
    Abbreviation: 'COST',
  },
  { DisplayName: '(UTC-05:00) Chetumal', Id: 'Eastern Standard Time (Mexico)', Abbreviation: 'ET' },
  { DisplayName: '(UTC-05:00) Eastern Time (US & Canada)', Id: 'Eastern Standard Time', Abbreviation: 'ET' },
  { DisplayName: '(UTC-05:00) Haiti', Id: 'Haiti Standard Time', Abbreviation: 'ET' },
  { DisplayName: '(UTC-05:00) Havana', Id: 'Cuba Standard Time', Abbreviation: 'Cuba Time' },
  { DisplayName: '(UTC-05:00) Indiana (East)', Id: 'US Eastern Standard Time', Abbreviation: 'ET' },
  { DisplayName: '(UTC-05:00) Turks and Caicos', Id: 'Turks And Caicos Standard Time', Abbreviation: 'ET' },
  { DisplayName: '(UTC-04:00) Asuncion', Id: 'Paraguay Standard Time', Abbreviation: 'PYT' },
  { DisplayName: '(UTC-04:00) Atlantic Time (Canada)', Id: 'Atlantic Standard Time', Abbreviation: 'AT' },
  { DisplayName: '(UTC-04:00) Caracas', Id: 'Venezuela Standard Time', Abbreviation: 'VET' },
  { DisplayName: '(UTC-04:00) Cuiaba', Id: 'Central Brazilian Standard Time', Abbreviation: 'Brazil Time' },
  {
    DisplayName: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    Id: 'SA Western Standard Time',
    Abbreviation: 'Bolivia Time',
  },
  { DisplayName: '(UTC-04:00) Santiago', Id: 'Pacific SA Standard Time', Abbreviation: 'Chile Time' },
  { DisplayName: '(UTC-03:30) Newfoundland', Id: 'Newfoundland Standard Time', Abbreviation: 'NT' },
  { DisplayName: '(UTC-03:00) Araguaina', Id: 'Tocantins Standard Time', Abbreviation: 'BRT' },
  { DisplayName: '(UTC-03:00) Brasilia', Id: 'E. South America Standard Time', Abbreviation: 'BRT' },
  {
    DisplayName: '(UTC-03:00) Cayenne, Fortaleza',
    Id: 'SA Eastern Standard Time',
    Abbreviation: 'French Guiana Time',
  },
  { DisplayName: '(UTC-03:00) City of Buenos Aires', Id: 'Argentina Standard Time', Abbreviation: 'ART' },
  { DisplayName: '(UTC-03:00) Greenland', Id: 'Greenland Standard Time', Abbreviation: 'Greenland Time' },
  { DisplayName: '(UTC-03:00) Montevideo', Id: 'Montevideo Standard Time', Abbreviation: 'UYT' },
  { DisplayName: '(UTC-03:00) Punta Arenas', Id: 'Magallanes Standard Time', Abbreviation: 'Chile Time' },
  {
    DisplayName: '(UTC-03:00) Saint Pierre and Miquelon',
    Id: 'Saint Pierre Standard Time',
    Abbreviation: 'PMT',
  },
  { DisplayName: '(UTC-03:00) Salvador', Id: 'Bahia Standard Time', Abbreviation: 'BRT' },
  { DisplayName: '(UTC-02:00) Coordinated Universal Time-02', Id: 'UTC-02', Abbreviation: 'UTC-2' },
  {
    DisplayName: '(UTC-02:00) Mid-Atlantic - Old',
    Id: 'Mid-Atlantic Standard Time',
    Abbreviation: 'Mid-Atlantic Standard Time Time',
  },
  { DisplayName: '(UTC-01:00) Azores', Id: 'Azores Standard Time', Abbreviation: 'Portugal Time' },
  {
    DisplayName: '(UTC-01:00) Cabo Verde Is.',
    Id: 'Cape Verde Standard Time',
    Abbreviation: 'Cape Verde Time',
  },
  { DisplayName: '(UTC) Coordinated Universal Time', Id: 'UTC', Abbreviation: 'UTC' },
  {
    DisplayName: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
    Id: 'GMT Standard Time',
    Abbreviation: 'GMT',
  },
  { DisplayName: '(UTC+00:00) Monrovia, Reykjavik', Id: 'Greenwich Standard Time', Abbreviation: 'GMT' },
  { DisplayName: '(UTC+00:00) Sao Tome', Id: 'Sao Tome Standard Time', Abbreviation: 'GMT' },
  { DisplayName: '(UTC+01:00) Casablanca', Id: 'Morocco Standard Time', Abbreviation: 'WET' },
  {
    DisplayName: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    Id: 'W. Europe Standard Time',
    Abbreviation: 'CET',
  },
  {
    DisplayName: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    Id: 'Central Europe Standard Time',
    Abbreviation: 'CET',
  },
  {
    DisplayName: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    Id: 'Romance Standard Time',
    Abbreviation: 'CET',
  },
  {
    DisplayName: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    Id: 'Central European Standard Time',
    Abbreviation: 'CET',
  },
  {
    DisplayName: '(UTC+01:00) West Central Africa',
    Id: 'W. Central Africa Standard Time',
    Abbreviation: 'WAT',
  },
  { DisplayName: '(UTC+02:00) Amman', Id: 'Jordan Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Athens, Bucharest', Id: 'GTB Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Beirut', Id: 'Middle East Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Cairo', Id: 'Egypt Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Chisinau', Id: 'E. Europe Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Damascus', Id: 'Syria Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Gaza, Hebron', Id: 'West Bank Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Harare, Pretoria', Id: 'South Africa Standard Time', Abbreviation: 'SAST' },
  {
    DisplayName: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    Id: 'FLE Standard Time',
    Abbreviation: 'EET',
  },
  { DisplayName: '(UTC+02:00) Jerusalem', Id: 'Israel Standard Time', Abbreviation: 'Israel Time' },
  { DisplayName: '(UTC+02:00) Juba', Id: 'South Sudan Standard Time', Abbreviation: 'CAT' },
  { DisplayName: '(UTC+02:00) Kaliningrad', Id: 'Kaliningrad Standard Time', Abbreviation: 'Kaliningrad Time' },
  { DisplayName: '(UTC+02:00) Khartoum', Id: 'Sudan Standard Time', Abbreviation: 'CAT' },
  { DisplayName: '(UTC+02:00) Tripoli', Id: 'Libya Standard Time', Abbreviation: 'EET' },
  { DisplayName: '(UTC+02:00) Windhoek', Id: 'Namibia Standard Time', Abbreviation: 'CAT' },
  { DisplayName: '(UTC+03:00) Baghdad', Id: 'Arabic Standard Time', Abbreviation: 'Iraq Time' },
  { DisplayName: '(UTC+03:00) Istanbul', Id: 'Turkey Standard Time', Abbreviation: 'Turkey Time' },
  { DisplayName: '(UTC+03:00) Kuwait, Riyadh', Id: 'Arab Standard Time', Abbreviation: 'Saudi Arabia Time' },
  { DisplayName: '(UTC+03:00) Minsk', Id: 'Belarus Standard Time', Abbreviation: 'Belarus Time' },
  {
    DisplayName: '(UTC+03:00) Moscow, St. Petersburg',
    Id: 'Russian Standard Time',
    Abbreviation: 'Moscow Time',
  },
  { DisplayName: '(UTC+03:00) Nairobi', Id: 'E. Africa Standard Time', Abbreviation: 'EAT' },
  { DisplayName: '(UTC+03:00) Volgograd', Id: 'Volgograd Standard Time', Abbreviation: 'Volgograd Time' },
  { DisplayName: '(UTC+03:30) Tehran', Id: 'Iran Standard Time', Abbreviation: 'IRST' },
  { DisplayName: '(UTC+04:00) Abu Dhabi, Muscat', Id: 'Arabian Standard Time', Abbreviation: 'GST' },
  {
    DisplayName: '(UTC+04:00) Astrakhan, Ulyanovsk',
    Id: 'Astrakhan Standard Time',
    Abbreviation: 'Astrakhan Time',
  },
  { DisplayName: '(UTC+04:00) Baku', Id: 'Azerbaijan Standard Time', Abbreviation: 'Azerbaijan Time' },
  { DisplayName: '(UTC+04:00) Izhevsk, Samara', Id: 'Russia Time Zone 3', Abbreviation: 'Samara Time' },
  { DisplayName: '(UTC+04:00) Port Louis', Id: 'Mauritius Standard Time', Abbreviation: 'Mauritius Time' },
  { DisplayName: '(UTC+04:00) Saratov', Id: 'Saratov Standard Time', Abbreviation: 'Saratov Time' },
  { DisplayName: '(UTC+04:00) Tbilisi', Id: 'Georgian Standard Time', Abbreviation: 'Georgia Time' },
  { DisplayName: '(UTC+04:00) Yerevan', Id: 'Caucasus Standard Time', Abbreviation: 'Armenia Time' },
  { DisplayName: '(UTC+04:30) Kabul', Id: 'Afghanistan Standard Time', Abbreviation: 'AFT' },
  {
    DisplayName: '(UTC+05:00) Ashgabat, Tashkent',
    Id: 'West Asia Standard Time',
    Abbreviation: 'Uzbekistan Time',
  },
  {
    DisplayName: '(UTC+05:00) Ekaterinburg',
    Id: 'Ekaterinburg Standard Time',
    Abbreviation: 'Yekaterinburg Time',
  },
  { DisplayName: '(UTC+05:00) Islamabad, Karachi', Id: 'Pakistan Standard Time', Abbreviation: 'PKT' },
  { DisplayName: '(UTC+05:00) Qyzylorda', Id: 'Qyzylorda Standard Time', Abbreviation: 'Kazakhstan Time' },
  {
    DisplayName: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    Id: 'India Standard Time',
    Abbreviation: 'IST',
  },
  { DisplayName: '(UTC+05:30) Sri Jayawardenepura', Id: 'Sri Lanka Standard Time', Abbreviation: 'IST' },
  { DisplayName: '(UTC+05:45) Kathmandu', Id: 'Nepal Standard Time', Abbreviation: 'NPT' },
  { DisplayName: '(UTC+06:00) Astana', Id: 'Central Asia Standard Time', Abbreviation: 'Kazakhstan Time' },
  { DisplayName: '(UTC+06:00) Dhaka', Id: 'Bangladesh Standard Time', Abbreviation: 'BST' },
  { DisplayName: '(UTC+06:00) Omsk', Id: 'Omsk Standard Time', Abbreviation: 'Omsk Time' },
  {
    DisplayName: '(UTC+06:30) Yangon (Rangoon)',
    Id: 'Myanmar Standard Time',
    Abbreviation: 'Myanmar (Burma) Time',
  },
  { DisplayName: '(UTC+07:00) Bangkok, Hanoi, Jakarta', Id: 'SE Asia Standard Time', Abbreviation: 'ICT' },
  {
    DisplayName: '(UTC+07:00) Barnaul, Gorno-Altaysk',
    Id: 'Altai Standard Time',
    Abbreviation: 'Barnaul Time',
  },
  { DisplayName: '(UTC+07:00) Hovd', Id: 'W. Mongolia Standard Time', Abbreviation: 'Mongolia Time' },
  { DisplayName: '(UTC+07:00) Krasnoyarsk', Id: 'North Asia Standard Time', Abbreviation: 'Krasnoyarsk Time' },
  {
    DisplayName: '(UTC+07:00) Novosibirsk',
    Id: 'N. Central Asia Standard Time',
    Abbreviation: 'Novosibirsk Time',
  },
  { DisplayName: '(UTC+07:00) Tomsk', Id: 'Tomsk Standard Time', Abbreviation: 'Tomsk Time' },
  {
    DisplayName: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    Id: 'China Standard Time',
    Abbreviation: 'China Time',
  },
  { DisplayName: '(UTC+08:00) Irkutsk', Id: 'North Asia East Standard Time', Abbreviation: 'Irkutsk Time' },
  { DisplayName: '(UTC+08:00) Kuala Lumpur, Singapore', Id: 'Singapore Standard Time', Abbreviation: 'SGT' },
  { DisplayName: '(UTC+08:00) Perth', Id: 'W. Australia Standard Time', Abbreviation: 'AWT' },
  { DisplayName: '(UTC+08:00) Taipei', Id: 'Taipei Standard Time', Abbreviation: 'Taiwan Time' },
  { DisplayName: '(UTC+08:00) Ulaanbaatar', Id: 'Ulaanbaatar Standard Time', Abbreviation: 'Mongolia Time' },
  { DisplayName: '(UTC+08:45) Eucla', Id: 'Aus Central W. Standard Time', Abbreviation: 'ACWT' },
  { DisplayName: '(UTC+09:00) Chita', Id: 'Transbaikal Standard Time', Abbreviation: 'Chita Time' },
  { DisplayName: '(UTC+09:00) Osaka, Sapporo, Tokyo', Id: 'Tokyo Standard Time', Abbreviation: 'Japan Time' },
  { DisplayName: '(UTC+09:00) Pyongyang', Id: 'North Korea Standard Time', Abbreviation: 'North Korea Time' },
  { DisplayName: '(UTC+09:00) Seoul', Id: 'Korea Standard Time', Abbreviation: 'South Korea Time' },
  { DisplayName: '(UTC+09:00) Yakutsk', Id: 'Yakutsk Standard Time', Abbreviation: 'Yakutsk Time' },
  { DisplayName: '(UTC+09:30) Adelaide', Id: 'Cen. Australia Standard Time', Abbreviation: 'ACT' },
  { DisplayName: '(UTC+09:30) Darwin', Id: 'AUS Central Standard Time', Abbreviation: 'ACT' },
  { DisplayName: '(UTC+10:00) Brisbane', Id: 'E. Australia Standard Time', Abbreviation: 'AET' },
  {
    DisplayName: '(UTC+10:00) Canberra, Melbourne, Sydney',
    Id: 'AUS Eastern Standard Time',
    Abbreviation: 'AET',
  },
  {
    DisplayName: '(UTC+10:00) Guam, Port Moresby',
    Id: 'West Pacific Standard Time',
    Abbreviation: 'Papua New Guinea Time',
  },
  { DisplayName: '(UTC+10:00) Hobart', Id: 'Tasmania Standard Time', Abbreviation: 'AET' },
  { DisplayName: '(UTC+10:00) Vladivostok', Id: 'Vladivostok Standard Time', Abbreviation: 'Vladivostok Time' },
  { DisplayName: '(UTC+10:30) Lord Howe Island', Id: 'Lord Howe Standard Time', Abbreviation: 'LHT' },
  {
    DisplayName: '(UTC+11:00) Bougainville Island',
    Id: 'Bougainville Standard Time',
    Abbreviation: 'Papua New Guinea Time',
  },
  { DisplayName: '(UTC+11:00) Chokurdakh', Id: 'Russia Time Zone 10', Abbreviation: 'Srednekolymsk Time' },
  { DisplayName: '(UTC+11:00) Magadan', Id: 'Magadan Standard Time', Abbreviation: 'Magadan Time' },
  {
    DisplayName: '(UTC+11:00) Norfolk Island',
    Id: 'Norfolk Standard Time',
    Abbreviation: 'Norfolk Island Time',
  },
  { DisplayName: '(UTC+11:00) Sakhalin', Id: 'Sakhalin Standard Time', Abbreviation: 'Sakhalin Time' },
  {
    DisplayName: '(UTC+11:00) Solomon Is., New Caledonia',
    Id: 'Central Pacific Standard Time',
    Abbreviation: 'Solomon Islands Time',
  },
  {
    DisplayName: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
    Id: 'Russia Time Zone 11',
    Abbreviation: 'Kamchatka Time',
  },
  { DisplayName: '(UTC+12:00) Auckland, Wellington', Id: 'New Zealand Standard Time', Abbreviation: 'NZT' },
  { DisplayName: '(UTC+12:00) Coordinated Universal Time+12', Id: 'UTC+12', Abbreviation: 'UTC+12' },
  { DisplayName: '(UTC+12:00) Fiji', Id: 'Fiji Standard Time', Abbreviation: 'Fiji Time' },
  {
    DisplayName: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
    Id: 'Kamchatka Standard Time',
    Abbreviation: 'Kamchatka Standard Time Time',
  },
  { DisplayName: '(UTC+12:45) Chatham Islands', Id: 'Chatham Islands Standard Time', Abbreviation: 'CHAT' },
  { DisplayName: '(UTC+13:00) Coordinated Universal Time+13', Id: 'UTC+13', Abbreviation: 'UTC+13' },
  { DisplayName: "(UTC+13:00) Nuku'alofa", Id: 'Tonga Standard Time', Abbreviation: 'Tonga Time' },
  { DisplayName: '(UTC+13:00) Samoa', Id: 'Samoa Standard Time', Abbreviation: 'Samoa Time' },
  {
    DisplayName: '(UTC+14:00) Kiritimati Island',
    Id: 'Line Islands Standard Time',
    Abbreviation: 'Kiribati Time',
  },
];

export const DEFAULT_LINK_CLASSES = 'link_underline bix-link'

/** Key for local storage of inital page request for Bixby in CSCP iframe. */
export const INITIAL_PAGE_REQUEST_PATH = 'INITIAL_PAGE_REQUEST_PATH';
export enum CscpEvents {
  /** When a user updates the URL in the CSCP window i.e. the iframe parent window. */
  CscpRouteChange = 'CSCP_ROUTE_CHANGE',
  /** When msal login redirect completes and has an account.*/
  CscpLoginRedirectSuccess = 'CSCP_LOGIN_REDIRECT_SUCCESS',
  /** Token for sent by CSCP window */
  CscpMsalTokenReceived = "CSCP_MSAL_TOKEN_RECEIVED",
}

/**
 * This must match src\utils\message.utils.ts
 * in common-web repo for CreditSights Cloud Platform
 * */
export enum MsalAppEvents {
  /**
   * When a user interacts with links in Bixby
   * we must emit the route change
   * to CSCP to mirror in the URL bar.
   */
  MsalAppRouteChange = 'ROUTE_CHANGE',

  /**
   * Once a user goes to the part of Bixby that
   * requires microsoft authentication we emit
   * a payload to the CSCP application to handle that. */
  MsalAppTriggerAuth = 'MSAL_AUTH',

  /** Get a token */
  MsalAppTokenRequest = "MSAL_APP_TOKEN_REQUEST",
}
